interface Props {
  quote: string;
  quoteAuthor?: string;
  authorCredentials?: string;
  alignment: string;
}

const Quote = ({ quote, quoteAuthor, authorCredentials }: Props) => {
  return (
    <div className="grid gap-y-3">
      <p className="tra-text-web-heading-6 text-center">&ldquo;{quote}&rdquo;</p>
      {quoteAuthor && (
        <p className="tra-text-web-sub-2 text-center">
          - {quoteAuthor}
          {authorCredentials && `, ${authorCredentials}`}
        </p>
      )}
    </div>
  );
};

export default Quote;
